export default {
    state: {
        records: [],
    },
    getters: {
        filterRecords: (state) => {
            var records = [];
            for (var i=0; i<state.records.length; i++) {
                records.push(state.records[i]);
            }
            return records;
        },
        getAllStudents: (state) =>{
            var list = [];
            for (var i=0; i<state.records.length; i++) {
                list.push(state.records[i]);
            }
            console.log("student get length", list.length);
            console.log("student get list", list);
            return list;
        },
    },
    mutations: {
        allStudents (state, data){
            state.records = data
        },
    },
    actions: {
        setAllStudents ({commit}, data){
            commit('allStudents', data)
        },
    }
}